import { render } from "./DirectSigninButton.vue?vue&type=template&id=0338e010&scoped=true&ts=true"
import script from "./DirectSigninButton.ts?vue&type=script&lang=ts&external"
export * from "./DirectSigninButton.ts?vue&type=script&lang=ts&external"

import "./DirectSigninButton.scss?vue&type=style&index=0&id=0338e010&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0338e010"]])

export default __exports__